import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './linkButton.css';
const LinkButton = (props) => {
  return (
    <a className="signiteLink" onClick={props.onClick}>
      <FontAwesomeIcon icon={props.icon || faPlusCircle} size="sm" /> <span>{props.label}</span>
    </a>
  );
};

export default LinkButton;
